export default {
  namespaced: true,
  state: {
    router: false
  },
  mutations: {
    setRouterLoading (state, value) {
      state.router = value
    }
  },
  actions: {

  }
}
